import type { FC } from 'react';
import Loader from 'react-spinners/ScaleLoader';

export const Spinner: FC = () => (
  <Loader loading color='#FF78C3' height={32} width={4} margin={4} radius={2} />
);
